import errorMessages from "utils/validation/errorMessages";
import { emailSchema, phoneRequiredSchema, select2OptionalSchema, select2RequiredSchema, statusSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, object, number } from 'yup';

const addHomeEducationSchema = object().shape({
	firstname: stringRequiredSchema,
	lastname: stringRequiredSchema,
	dob: stringRequiredSchema,
	gender: select2RequiredSchema,
	// service_status: select2RequiredSchema,
	grade: select2OptionalSchema,
	city_town: stringRequiredSchema,
	parents: array().of(object().shape({
		firstname: stringRequiredSchema,
		lastname: select2RequiredSchema,
		phone: phoneRequiredSchema,
		email: emailSchema,
		id: number().nullable().optional()
	})),
	documents: array().of(object().shape({
		attachment_key: stringRequiredSchema,
		attachment_name: stringRequiredSchema
	})),
	status: statusSchema,
	education_authority: stringOptionalSchema,
	intake_date: stringOptionalSchema
});

export default addHomeEducationSchema;